import React, { Component } from 'react';
import { useLocation } from 'react-router-dom';
import { ProgramPlusCard, ProgramPlusCardStyles } from './ProgramPlusCard';
import { ProgramFilters, applyProgramFilters, emptyFilters } from './ProgramFilters';

export function ProgramSearch(props) {
    var location = useLocation();
    return <ProgramSearchInner {...props} search={location.search} />;
}

class ProgramSearchInner extends Component {
    constructor(props) {
        super(props);
        var saved = {};
        try {
            var raw = sessionStorage.getItem('programSearchFilters');
            if (raw) saved = JSON.parse(raw);
        } catch {}

        // Read query params (e.g. ?hashtag=xxx)
        var queryFilters = {};
        try {
            if (typeof window !== 'undefined' && window.location.search) {
                var params = new URLSearchParams(window.location.search);
                var tag = params.get('hashtag');
                if (tag) queryFilters.hashtags = [tag];
                var kw = params.get('keyword');
                if (kw) queryFilters.keyword = kw;
            }
        } catch {}

        // Detect back/forward navigation — if user came back, prefer saved over query
        var isBackNav = false;
        try {
            var nav = performance.getEntriesByType('navigation')[0];
            if (nav && nav.type === 'back_forward') isBackNav = true;
        } catch {}

        var hasQuery = Object.keys(queryFilters).length > 0;
        var hasSaved = Object.keys(saved).length > 0;
        var initialFilters;
        if (isBackNav && hasSaved) {
            initialFilters = { ...emptyFilters, ...saved };
        } else if (hasQuery) {
            initialFilters = { ...emptyFilters, ...queryFilters };
        } else {
            initialFilters = { ...emptyFilters, ...saved };
        }

        this.state = {
            loading: true,
            programs: [],
            continents: [],
            countries: [],
            regions: [],
            provinces: [],
            filters: initialFilters
        };
        try { sessionStorage.setItem('programSearchFilters', JSON.stringify(initialFilters)); } catch {}
    }

    setFilters = (f) => {
        this.setState({ filters: f });
        try { sessionStorage.setItem('programSearchFilters', JSON.stringify(f)); } catch {}
    }

    componentDidMount() {
        Promise.all([
            fetch('api/programplus').then(r => r.ok ? r.json() : []),
            fetch('api/programplus/continents/master').then(r => r.ok ? r.json() : []),
            fetch('api/programplus/countries/master').then(r => r.ok ? r.json() : []),
            fetch('api/programplus/regions/master').then(r => r.ok ? r.json() : []),
            fetch('api/programplus/provinces/master').then(r => r.ok ? r.json() : [])
        ]).then(([programs, continents, countries, regions, provinces]) => {
            this.setState({ programs, continents, countries, regions, provinces, loading: false });
        }).catch(() => this.setState({ loading: false }));
    }

    componentDidUpdate(prevProps) {
        if (prevProps.search !== this.props.search) {
            var queryFilters = {};
            try {
                var params = new URLSearchParams(this.props.search || '');
                var tag = params.get('hashtag');
                if (tag) queryFilters.hashtags = [tag];
                var kw = params.get('keyword');
                if (kw) queryFilters.keyword = kw;
            } catch {}
            var next = { ...emptyFilters, ...queryFilters };
            this.setState({ filters: next });
            try { sessionStorage.setItem('programSearchFilters', JSON.stringify(next)); } catch {}
        }
    }

    render() {
        var { loading, continents, countries, regions, provinces, programs, filters } = this.state;
        var filtered = applyProgramFilters(programs, filters, countries, provinces);

        return (
            <div style={{ background:'#f4f3ef', minHeight:'100vh', padding:'20px 0' }}>
                <ProgramPlusCardStyles />
                <div className="container">
                    <h3 style={{ color:'#dc3545', fontWeight:800, marginBottom:20 }}>
                        <i className="fas fa-search"></i> ค้นหาโปรแกรมทัวร์
                    </h3>

                    <ProgramFilters filters={filters} onChange={this.setFilters}
                        continents={continents} countries={countries} regions={regions} provinces={provinces} />

                    <div style={{ fontSize:14, color:'#666', marginBottom:12 }}>
                        พบ {filtered.length} รายการ
                    </div>

                    {loading ? (
                        <div className="row">
                            {[0,1,2].map(i => (
                                <div key={i} className="col-md-6 col-lg-4 mb-4">
                                    <ProgramPlusCard loading={true} />
                                </div>
                            ))}
                        </div>
                    ) : filtered.length === 0 ? (
                        <div className="text-center py-5" style={{ color:'#bbb' }}>
                            <i className="fas fa-inbox" style={{ fontSize:48, display:'block', marginBottom:12 }}></i>
                            ไม่พบโปรแกรมที่ตรงกับเงื่อนไขการค้นหา
                        </div>
                    ) : (
                        <div className="row">
                            {filtered.map(p => (
                                <div key={p.id} className="col-md-6 col-lg-4 mb-4">
                                    <ProgramPlusCard p={p} linkTo={'/programplus/view/' + p.id} />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
